export const buildCodingPlanConfigV95 = (config = {}) => {
  const strategy = config.key_usage_strategy_v95 || 'round_robin';
  if (!['round_robin', 'coding_plan'].includes(strategy)) {
    throw new Error('channel.edit.coding_plan_v95.invalid_strategy');
  }
  let hours = Number(config.coding_plan_cooldown_hours_v95 ?? 5);
  if (!Number.isInteger(hours) || hours < 1 || hours > 168) {
    if (strategy === 'coding_plan') {
      throw new Error('channel.edit.coding_plan_v95.invalid_hours');
    }
    hours = 5;
  }
  return {
    ...config,
    key_usage_strategy_v95: strategy,
    coding_plan_cooldown_hours_v95: hours,
  };
};

export const buildCodingPlanKeysV95 = (rows) =>
  rows.flatMap((row) => {
    const group = String(row.quota_group_v95 || '').trim();
    if (
      new TextEncoder().encode(group).length > 64 ||
      /[\x00-\x1f\x7f]/.test(group)
    ) {
      throw new Error('channel.edit.coding_plan_v95.invalid_group');
    }
    const base = {
      quota_group_v95: group,
      llm_concurrency_limit: Number(row.llm_concurrency_limit ?? 0),
      image_concurrency_limit: Number(row.image_concurrency_limit ?? 2),
    };
    if (row.key_masked) {
      return [{ ...base, id: Number(row.id), key_value: '' }];
    }
    return String(row.key_value || '')
      .split(/\r?\n/)
      .map((value) => value.trim())
      .filter(Boolean)
      .map((value) => ({ ...base, key_value: value }));
  });

export const preserveCodingPlanRowsV95 = (current, revealed) => {
  const previous = new Map(current.map((row) => [String(row.id), row]));
  return revealed
    .map((row) => {
      const draft = previous.get(String(row.id));
      return draft
        ? { ...row, quota_group_v95: draft.quota_group_v95 || '' }
        : row;
    })
    .concat(
      current.filter(
        (row) => String(row.id).startsWith('new-') && row.key_value
      )
    );
};
